import { create } from 'zustand';

const initialState = {
    data: [],
    total: 0,
    totalDay: 0,
    percentTotal: 0,
    title: ''
};

export const useNotEscaletedLinesNextStore = create((set) => ({

    ...initialState,

    setNotEscaletedLinesNext: ({
        data,
        total,
        totalDay,
        percentTotal,
        title
    }) => {
        set({
            data,
            total,
            totalDay,
            percentTotal,
            title
        });
    },

    clearNotEscaletedLinesNext: () => {
        set(initialState);
    }

}));